import React, { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import { ACTIVE_ACCOUNT_TYPE_COOKIE } from '../constants/cookies'

const Access = ({ accept, children }) => {
    const [show, setShow] = useState(false)
    const [cookies] = useCookies()

    const processTypes = () => {
        let activeRole = null
        try {
            activeRole = typeof cookies[ACTIVE_ACCOUNT_TYPE_COOKIE] === 'string' 
                ? JSON.parse(cookies[ACTIVE_ACCOUNT_TYPE_COOKIE])
                : cookies[ACTIVE_ACCOUNT_TYPE_COOKIE]
        } catch (e) {
            console.warn('Error parsing activeAccountType cookie:', e)
        }

        if (!activeRole && !accept) return
        if (!accept) return setShow(true)

        const acceptId = accept.map(type => type.id)
        if (acceptId.includes(activeRole?.id)) {
            setShow(true)
        }
    }
    useEffect(processTypes, [cookies, accept])

    return <>{show && children}</>
}

export const useAccount = () => {
    const [cookies] = useCookies();
    const cookieValue = cookies[ACTIVE_ACCOUNT_TYPE_COOKIE];
    return typeof cookieValue === 'string' ? JSON.parse(cookieValue) : cookieValue;
}

export default Access
